import Vue from 'vue';
import {Constants as constants} from '../../config/constants';
import InitComponent from './components/main/init.vue';
import {FileMapping} from '@/types/data';

export class ImportMenu {
    private static instance = null as Vue | null;

    constructor(private files: FileMapping[]) {
        this.initChart();
    }

    private initChart() {
        if (!ImportMenu.instance) {
            ImportMenu.instance = new Vue({
                el: `#${constants.importMenuId}`,
                render: (h) => h(InitComponent, {
                    props: {
                        files: this.files.slice(0)
                    }
                }),
                components: {
                    init: InitComponent
                }
            });
        }
    }
}
